// The list endpoint nests usage under `limits`; GET /:id returns the flat row.
export const getAccountLimits = (account = {}) => ({
  connectionsUsed: account.limits?.connections?.used ?? account.connectionsSentToday ?? 0,
  connectionsTotal: account.limits?.connections?.total ?? account.dailyConnectionLimit ?? 0,
  messagesUsed: account.limits?.messages?.used ?? account.messagesSentToday ?? 0,
  messagesTotal: account.limits?.messages?.total ?? account.dailyMessageLimit ?? 0,
});

// Connected senders can still be blocked (e.g. "LinkedIn CAPTCHA detected").
export const accountNeedsAttention = (account = {}) =>
  Boolean(account.needsAttention || account.connectionError || account.status !== "ACTIVE" || !account.isConnected);
